import { Icons } from '@/components/icons';
import QuantaIcons from '@/app/quanta/components/Icons';
import { FEATURES } from '@/constants';

interface SidebarItem {
  name: string;
  href: string;
  icon?: React.ReactNode;
  subItems?: SidebarItem[];
}

interface InfoItem {
  icon: React.ReactNode;
  name: string;
  href: string;
}

export const sidebarData: SidebarItem[] = [
  {
    icon: <Icons.overview />,
    name: 'Protocol',
    href: '/overview',
    subItems: [
      {
        name: 'Ducat Reserve',
        href: '/overview/reserve',
      },
    ],
  },
  {
    icon: <Icons.vault />,
    name: 'Vault',
    href: '/',
  },
  {
    icon: <Icons.swap />,
    name: 'UNIT Swap',
    href: '/swap',
  },
  {
    icon: <Icons.faucet />,
    name: 'BTC Faucet',
    href: '/faucet',
  },
  {
    icon: <Icons.liquidations />,
    name: 'Liquidations',
    href: '/liquidations',
    subItems: FEATURES.liquidations
      ? [
          {
            name: 'Leaderboard',
            href: '/liquidations/leaderboard',
          },
        ]
      : [],
  },
  // {
  //   icon: <Icons.market />,
  //   name: "Add-ons",
  //   href: "/add-ons",
  // },
  {
    icon: <Icons.governance />,
    name: 'Governance',
    href: '/governance',
  },
  {
    icon: <Icons.quanta />,
    name: 'Earn Quanta',
    href: '/quanta',
    subItems: [
      {
        name: 'Missions',
        href: '/quanta/missions',
      },
      {
        name: 'Side Missions',
        href: '/quanta/side-missions',
      },
      {
        name: 'Leaderboard',
        href: '/quanta/leaderboard',
      },
    ],
  },
];

export const infoData: InfoItem[] = [
  {
    icon: <Icons.file />,
    name: 'File',
    href: 'https://docs.ducatprotocol.com',
  },
  {
    icon: <Icons.twitter />,
    name: 'Twitter',
    href: 'https://x.com/Ducatstable',
  },
  {
    icon: <Icons.discord />,
    name: 'Discord',
    href: 'https://discord.gg/ducat',
  },
  {
    icon: <Icons.telegramSideBar />,
    name: 'Telegram',
    href: 'http://t.me/ducat_announcements',
  },
];
